export const SET_TOKEN = 'SET_TOKEN';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_BRANCH = 'SET_BRANCH';
export const SET_SIP_INFO = 'SET_SIP_INFO';
export const CLEAR = 'CLEAR';
